/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useState, useRef } from 'react'
import moment from 'moment'
import Grid, { virtualizedGridRenderer } from '@integec/grid-tools'
import { strCol } from '@integec/grid-tools/lib/cols'
import { Button, Col, InputNumber, Modal, Row, Select } from 'antd'
import { getCard97 } from 'api/pgads'
import { FullHeightSizer } from 'core/screen-util'
import { rowHeaderRender } from 'core/utils'

const header = [
  strCol({
    ident: 'unitName',
    display: 'Unit',
    width: 250,
  }),
  strCol({
    ident: 'year',
    display: 'Year',
    width: 60,
  }),
  strCol({
    ident: 'eventNum',
    display: 'Event Number',
    width: 60,
  }),
  strCol({
    ident: 'eventType',
    display: 'Event Type',
    width: 60,
  }),
  strCol({
    ident: 'causeCode',
    display: 'Cause Code',
    width: 60,
  }),
  strCol({
    ident: 'availCap',
    display: 'Available Capacity',
    width: 70,
  }),
  strCol({
    ident: 'eventStart',
    display: 'Event Start',
    width: 150,
  }),
  strCol({
    ident: 'eventEnd',
    display: 'Event End',
    width: 150,
  }),
]

const SelectEvents = ({
  apiTargetInfo,
  //  fromDate,
  units,
  onOk,
  onCancel,
  setError,
  minYear,
  maxYear,
  eventTypes,
}) => {
  const [year, setYear] = useState(minYear)
  const [currentUnit, setCurrentUnit] = useState(
    `${units[0].utility}${units[0].unit}`
  )
  const [events, setEvents] = useState()
  const selectedRows = useRef([])

  const retrieveEvents = () => {
    const u = units.find(r => `${r.utility}${r.unit}` === currentUnit)
    getCard97(apiTargetInfo)(
      year,
      null,
      [currentUnit],
      eventTypes.map(e => e.eventType)
    ).fork(setError, d =>
      setEvents(
        d.map(r => ({
          ...r,
          unitName: `${u.unitName} (${u.utility}-${u.unit})`,
          unit: u.unit,
          eventStart: moment(r.eventStart).format('MM/DD/YYYY HH:mm'),
          eventEnd: moment(r.eventEnd).format('MM/DD/YYYY HH:mm'),
        }))
      )
    )
  }

  return (
    <Modal
      title="Select events to exclude"
      width="950px"
      bodyStyle={{ overflowY: 'auto' }}
      visible
      onOk={() => onOk(selectedRows.current)}
      okText="Exclude Selection"
      onCancel={onCancel}
      centered
      maskClosable={false}
    >
      <FullHeightSizer heightOffset={300}>
        {({ height, width }) => (
          <>
            <Row type="flex" align="bottom">
              <Col span={3}>
                <InputNumber
                  name="year"
                  min={minYear}
                  max={maxYear}
                  value={year}
                  onChange={v => setYear(v)}
                />
              </Col>
              <Col span={10}>
                <Select
                  name="units"
                  css={{ width: '100%' }}
                  value={currentUnit}
                  onChange={v => setCurrentUnit(v)}
                >
                  {units.map(u => (
                    <Select.Option key={`${u.utility}${u.unit}`}>
                      {u.unitName} ({u.utility}-{u.unit})
                    </Select.Option>
                  ))}
                </Select>
              </Col>
              <Col>
                <Button
                  type="primary"
                  css={{ marginLeft: '15px' }}
                  onClick={retrieveEvents}
                >
                  Filter for events
                </Button>
              </Col>
            </Row>
            <Row>
              <Col span={24} css={{ marginTop: '15px' }}>
                <Grid
                  data={events || []}
                  headers={header}
                  altBgColor="#ebebeb"
                  render={virtualizedGridRenderer({
                    autoFixColByKey: true,
                    rowHeaderRender,
                    height: height - 50,
                    width: width - 20,
                  })}
                  selectionType="row"
                  onSelectionChange={rows => {
                    selectedRows.current = rows.selectedRows
                  }}
                />
              </Col>
            </Row>
          </>
        )}
      </FullHeightSizer>
    </Modal>
  )
}

export default SelectEvents
